module.exports = __webpack_public_path__ + "img/add_col_after.58580961.svg";